export default __webpack_public_path__ + "static/media/info-lock.783207e5.png";